import { Link } from "react-router-dom";

const LinkYourStore = ({ handleButtonClick }) => {
 return (
  <div className="inside-hero-one hero-spacing mx-0" data-aos="fade-up">
   <div className="container">
    <h2 className="page-title">
     Conecta tu tienda con Meta y Google Ads
     <br /> y obtén más ventas en un ¡Bizz!
    </h2>
    <div className="flex items-center justify-center">
     <p>
      Todas las tiendas PoweBizz tienen conexión con Meta y Google Ads para que
      tengas alta conversion en ventas.
     </p>
    </div>
    <div className="flex justify-center mt-20 ">
     <Link
      className="theme-btn-one"
      to={"/nueva-tienda"}
      onClick={() =>
       handleButtonClick("Beneficios", "clic en boton", "Conectar Meta")
      }
     >
      Comenzar
     </Link>
    </div>
   </div>
  </div>
 );
};

export default LinkYourStore;
